module.exports = __webpack_public_path__ + "../resources/img/pop_img.18049ebc.png";